import { lazy } from 'react';
import { SuspenseBoundary } from '@mews-commander/ui';

const LazyComponent = lazy(
    async () => import(/* webpackChunkName: "TotalMatchingGuestProfile" */ '../components/TotalMatchingGuestProfile')
);

export const TotalMatchingGuestProfileContainer = () => (
    <SuspenseBoundary loader="inline">
        <LazyComponent />
    </SuspenseBoundary>
);
